import { useUserStore } from '../store/user'
import { resolvePostAuthRoute } from './contextSelection'

/**
 * Named route for shell Home (`/home`, logo, breadcrumbs) after context is complete.
 * Same landing as login and branch/location selection — never a hard-coded dashboard.
 */
export function authorizedLandingRouteName(): string {
  const userStore = useUserStore()
  return resolvePostAuthRoute(
    null,
    userStore.defaultDashboard,
    (slug) => userStore.hasModule(slug),
    (action, subject) => userStore.hasPermission(action, subject),
  )
}
